import { SendEligibilitySignatureRequest, Task } from "@/types";

interface CanSendPandaDocParams {
  canEdit: boolean;
  hasPandaDoc: boolean;
  isSignatureEligible: boolean;
}

/**
 * Determines if a PandaDoc can be sent for a task.
 * Record type eligibility is determined by the backend via is_signature_eligible.
 */
export function canSendPandaDoc({ canEdit, hasPandaDoc, isSignatureEligible }: CanSendPandaDocParams): boolean {
  if (!canEdit || hasPandaDoc) return false;
  return isSignatureEligible;
}

/**
 * Derives canSendPandaDoc params from a Task object
 */
export function getCanSendPandaDocParams(task: Task | undefined) {
  return {
    hasPandaDoc: !!task?.pandadoc,
    isSignatureEligible: task?.is_signature_eligible ?? false,
  };
}

export const DEFAULT_PANDADOC_FORM_DATA: SendEligibilitySignatureRequest = {
  recipient: {},
  additional_recipients: [],
  reply_to: {},
  message: "",
};
